import styled from 'styled-components'

interface IFileViewerEmptyPreviewStyledProps {}

export const FileViewerEmptyPreviewStyled = styled.div<IFileViewerEmptyPreviewStyledProps>`
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
`
